module.exports = __webpack_public_path__ + "img/blue_126.7fefdd09.png";